export const langPath = {
  fr: {
    sessionsLink: 'Sessions',
    sessionStatsLink: 'Détails session',
    pathLink: 'Parcours',
    speed: 'Vitesse',
    measureBtn: 'Mesurer des distances',
    help: [
      `Utilisez le bouton Play pour lancer l'animation.`,
      `Une fois l'animation lancée, cliquez sur le graphe des vitesses pour aller rapidement à une phase du parcours.`,
      `Le déplacement est représenté sur la carte et sur le graphe par des symboles de même couleur.`,
      ` `,
      `Activez la petite règle sur la carte pour mesurer des distances.`,
    ],
    sourceFile: `Source : `,
    backToStats: `< Retour aux stats de la session`,
  },
  eng: {
    sessionsLink: 'Sessions',
    sessionStatsLink: 'Session details',
    pathLink: 'Path',
    speed: 'Speed',
    measureBtn: 'Measure distances',
    help: [
      `Use the Play button to start the animation.`,
      `Once the animation is launched, click on the speed graph to quickly move to a phase of the path.`,
      `Movement is represented on the map and on the graph by symbols of the same colour.`,
      ` `,
      `Activate the small ruler on the map to measure distances.`,
    ],
    sourceFile: `Source : `,
    backToStats: `< Back to session stats`,
  },
}
